export default __webpack_public_path__ + "static/logo-063a631953ee29952a14a6153a4e001d.svg";